import React, { type FC, type PropsWithChildren, type HTMLAttributes, type MouseEventHandler } from 'react';

import Box from '../box/box';
import Icon from '../icon/icon';
import Button from '../button/button';

export interface PauseOverlayProps extends HTMLAttributes<HTMLButtonElement> {
  /** Determines state button ("Play" vs "Pause") */
  isVideoPlaying: boolean;
  /** Event handler run when button is clicked */
  onClick: MouseEventHandler;
}

const PauseOverlay: FC<PropsWithChildren<PauseOverlayProps>> = ({
  children,
  className,
  onClick,
  isVideoPlaying,
  ...rest
}) => (
  <Box
    css={[
      {
        label: 'pauseOverlayButton',
        position: 'relative',
        cursor: 'pointer',
        zIndex: 10,
      },
      {
        '&:hover > button, & > button:focus-visible': {
          clip: 'auto',
          clipPath: 'none',
        },
      },
    ]}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
  >
    {children}
    <Box
      css={{
        position: 'absolute',
        zIndex: 100,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        height: '100%',
        width: '100%',
        margin: 'auto',
      }}
      onClick={onClick}
    />
    <Button
      {...rest}
      css={theme => ({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        padding: '16px 26px',
        fontSize: theme.fontSizes.fs16,
        position: 'absolute',
        left: '50%;',
        bottom: '0',
        transform: 'translateX(-50%)',
        zIndex: 101,
      })}
      onClick={onClick}
      type="button"
    >
      <Icon type={isVideoPlaying ? 'Pause' : 'Play'} />
    </Button>
  </Box>
);

export { PauseOverlay };
export default PauseOverlay;
